import React from "react";

interface MemberType {
  appointmentMemberYn: string;
  chargeMemberYn: string;
  isSmall: boolean;
  isMember?: boolean;
}

const MemberType = ({
  appointmentMemberYn,
  chargeMemberYn,
  isSmall,
  isMember = true,
}: MemberType) => {
  if (appointmentMemberYn === "N" && chargeMemberYn === "N" && isMember) {
    return <></>;
  }

  return (
    <div className={`member-type${isSmall ? " small" : ""}`}>
      {appointmentMemberYn === "Y" && (
        <div className={`member-type-box purple${isSmall ? " small" : ""}`}>
          <span>개인레슨</span>
        </div>
      )}
      {chargeMemberYn === "Y" && (
        <div className={`member-type-box blue${isSmall ? " small" : ""}`}>
          <span>관리담당</span>
        </div>
      )}
      {!isMember && (
        <div className={`member-type-box gray${isSmall ? " small" : ""}`}>
          <span>미회원</span>
        </div>
      )}
    </div>
  );
};

export default MemberType;
